module.exports = "/assets/e993a9e4135362092709ad7446498134.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PX.png
// module id = 1732
// module chunks = 0